/* eslint-disable no-unused-vars */
import { put, call } from 'redux-saga/effects'
import _ from 'lodash'

export function makeRequest(request, returnType) {
    return request()
        .then(response => response[returnType]().then(result => ({ result, response })))
        .then(({ result, response }) => {
            if (!response.ok) {
                throw result
            }
            return result
        })
}

export default function* callApi(request, action, callback = r => {}, returnType = 'json') {
    try {
        yield put({ type: 'worker', data: { work: action, status: 'busy' } })
        const response = yield call(makeRequest, request, returnType)
        const responseObject = _.get(response, 'reqdata.response', '')
        if (
            !_.get(response, `result.api.skiprequest`, false) &&
            _.get(response, `result.api.${responseObject}.@attributes.success`, 'false') == 'false'
        ) {
            const msgs = _.get(response, `result.api.${responseObject}.Messages`, '')
            yield put({ type: 'api.ex', error: msgs, response })
            yield put({ type: 'worker', data: { work: action, status: 'ready' } })
        } else {
            yield put({ type: action + '.ok', response })
            yield put({ type: 'worker', data: { work: action, status: 'ready' } })
            return response
        }
    } catch (error) {
        yield put({ type: action + '.ex', error: error })
        yield put({ type: 'worker', data: { work: action, status: 'ready' } })
        throw error
    }
}

export function* callModelData(request, action, callback = r => {}, returnType = 'json') {
    try {
        yield put({ type: 'worker', data: { work: action, status: 'busy' } })
        const response = yield call(makeRequest, request, returnType)

        yield put({ type: action + '.ok', response })
        yield put({ type: 'worker', data: { work: action, status: 'ready' } })
        return response
    } catch (error) {
        yield put({ type: action + '.ex', error: error })
        yield put({ type: 'worker', data: { work: action, status: 'ready' } })
        throw error
    }
}
